<app-card>
  <div header>
    <div class="d-flex step-title">
      <div class="justify-content-start mr-0">
        <p>{{'baselinker' | translate}}</p>
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div *ngIf="!hasPermission">
        <div class="pl-5 no-acces">
          <span>{{'noAccessToBaselinker' | translate}}</span>
        </div>
    </div>
    <div *ngIf="loadingToken && hasPermission" class="d-flex justify-content-center">
      <mat-spinner></mat-spinner>
    </div>
    <div *ngIf="!loadingToken && hasPermission" class="col-sm-6 col-xl-4 offset-xl-1">
      <div class="row section">
        <div class="d-flex align-items-center px-5">
          <mat-form-field class="token-form-field" appearance="fill">
            <mat-label>{{'baselinker' | translate}}</mat-label>
            <input matInput type="text" [(ngModel)]="token" readonly>
            <button matSuffix mat-icon-button [cdkCopyToClipboard]="token" matTooltip="{{'copyToken' | translate}}">
              <mat-icon>content_copy</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="px-5">
        <button  mat-flat-button color="primary" (click)="startTokenRegeneration()">
          {{'refreshToken' | translate}}
        </button>
        </div>
      </div>
    </div>
  </div>

</app-card>